export class MoveListModel {
  public DestinationFolderId: number;
  public ListIds: Array<number>;

  constructor(init: any) {
    this.DestinationFolderId = init.DestinationFolderId;
    this.ListIds = init.ListIds;
  }
}
